var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card has-background-dark has-text-light"},[_c('div',{staticClass:"card-header"},[_c('div',{staticClass:"column"},[_vm._v(" Vacantes ")])]),_c('div',{staticClass:"card-content"},[_vm._v(" Este módulo contiene las vacantes abiertas de esta empresa ")])])
}]

export { render, staticRenderFns }